module.exports = __webpack_public_path__ + "static/media/tin-can.e3ae58aa.svg";